import classNames from 'classnames';
import React from 'react';
import { Button } from '@udemy/react-core-components';
import styles from "./skills-hub-banner.module.css";
/**
 *
 * The SkillsHubBanner component.
 *
 * @remarks
 *
 * This is currently used to render a banner above/around the SkillsHubUnit.
 */
export const SkillsHubBanner = ({
  topicId,
  topicTagline,
  topicDescription,
  ctaText,
  ctaLink,
  onCtaClick
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: styles['banner-wrapper']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement("h2", {
    className: classNames('ud-heading-xl', styles.tagline)
  }, topicTagline), /*#__PURE__*/React.createElement("p", {
    className: classNames('ud-text-md', styles.description)
  }, topicDescription)), /*#__PURE__*/React.createElement(Button, {
    componentClass: "a",
    href: ctaLink,
    size: "medium",
    udStyle: "secondary",
    onClick: () => onCtaClick === null || onCtaClick === void 0 ? void 0 : onCtaClick(topicId)
  }, ctaText));
};
//# sourceMappingURL=skills-hub-banner.react-component.js.map